import { ClassEnrollment } from '@/models/ClassEnrollment';
import { CourseEnrollment } from '@/models/CourseEnrollment';
import { CourseLessonContentTO } from '@/models/CourseLessonContentTO';
import List from '@/models/List';
import { ProgramClass } from '@/models/ProgramClass';
import { ScormStatus } from '@/models/ScormStatus';
import { AxiosError } from 'axios';

export enum ListTypes {
    GET_LISTS_CLEAR = '@list/GET_LISTS_CLEAR',
    POST_LIST_CLEAR = '@list/POST_LIST_CLEAR',
    PUT_LIST_CLEAR = '@list/PUT_LIST_CLEAR',
    DELETE_LIST_CLEAR = '@list/DELETE_LIST_CLEAR',
    PUBLISH_LIST_CLEAR = '@list/PUBLISH_LIST_CLEAR',
    ARCHIVE_LIST_CLEAR = '@list/ARCHIVE_LIST_CLEAR',
    TOGGLE_LIST_VISIBILITY_CLEAR = '@list/ARCHIVE_LIST_CLEAR',
    GET_LIST_REQUEST = '@list/GET_LIST_REQUEST',
    GET_LIST_SUCCESS = '@list/GET_LIST_SUCCESS',
    GET_LIST_FAILURE = '@list/GET_LIST_FAILURE',
    GET_LIST_CLEAR = '@list/GET_LIST_CLEAR',
    GET_LISTS_REQUEST = '@list/GET_LISTS_REQUEST',
    GET_LISTS_SUCCESS = '@list/GET_LISTS_SUCCESS',
    GET_LISTS_SUCCESS_FECTH_MORE = '@list/GET_LISTS_SUCCESS_FETCH_MORE',
    GET_LISTS_FAILURE = '@list/GET_LISTS_FAILURE',
    POST_LIST_REQUEST = '@list/POST_LIST_REQUEST',
    POST_LIST_SUCCESS = '@list/POST_LIST_SUCCESS',
    POST_LIST_FAILURE = '@list/POST_LIST_FAILURE',
    PUT_LIST_REQUEST = '@list/PUT_LIST_REQUEST',
    PUT_LIST_SUCCESS = '@list/PUT_LIST_SUCCESS',
    PUT_LIST_FAILURE = '@list/PUT_LIST_FAILURE',
    DELETE_LIST_REQUEST = '@list/DELETE_LIST_REQUEST',
    DELETE_LIST_SUCCESS = '@list/DELETE_LIST_SUCCESS',
    DELETE_LIST_FAILURE = '@list/DELETE_LIST_FAILURE',
    PUBLISH_LIST_REQUEST = '@list/PUBLISH_LIST_REQUEST',
    PUBLISH_LIST_SUCCESS = '@list/PUBLISH_LIST_SUCCESS',
    PUBLISH_LIST_FAILURE = '@list/PUBLISH_LIST_FAILURE',
    ARCHIVE_LIST_REQUEST = '@list/ARCHIVE_LIST_REQUEST',
    ARCHIVE_LIST_SUCCESS = '@list/ARCHIVE_LIST_SUCCESS',
    ARCHIVE_LIST_FAILURE = '@list/ARCHIVE_LIST_FAILURE',
    REFRESH_LIST = '@list/REFRESH_LIST',
    TOGGLE_LIST_VISIBILITY_REQUEST = '@list/TOGGLE_LIST_VISIBILITY_REQUEST',
    TOGGLE_LIST_VISIBILITY_SUCCESS = '@list/TOGGLE_LIST_VISIBILITY_SUCCESS',
    TOGGLE_LIST_VISIBILITY_FAILURE = '@list/TOGGLE_LIST_VISIBILITY_FAILURE',
    COURSES_REQUEST = '@courses/COURSES_REQUEST',
    ESSENTIAL_SUCCESS = '@courses/ESSENTIAL_SUCCESS',
    PUBLISHED_USER_CONTENTS_SUCCESS = '@courses/PUBLISHED_USER_CONTENTS_SUCCESS',
    LAST_PUBLISHED_SUCCESS = '@courses/LAST_PUBLISHED_SUCCESS',
    MOST_ACCESSED_SUCCESS = '@courses/MOST_ACCESSED_SUCCESS',
    IN_PROGRESS_SUCCESS = '@courses/IN_PROGRESS_SUCCESS',
    COMPLETED_SUCCESS = '@courses/COMPLETED_SUCCESS',
    TOP_RATED_SUCCESS = '@course/TOP_RATED_SUCCESS',
    COURSES_HAVING_A_CONTENT_CLEAR = '@course/COURSES_HAVING_A_CONTENT_CLEAR',
    COURSES_HAVING_A_CONTENT_SUCCESS = '@course/COURSES_HAVING_A_CONTENT_SUCCESS',
    CATEGORIZED_SUCCESS = '@courses/CATEGORIZED_SUCCESS',
    FAVORITES_SUCCESS = '@course/FAVORITES_SUCCESS',
    COURSES_FAILURE = '@courses/COURSES_FAILURE',
    ADD_LIST_BY_CATEGORY = '@courses/ADD_LIST_BY_CATEGORY',
    FOR_YOU_SUCCESS = '@courses/FOR_YOU_SUCCESS',
    LIKE_YOU_SUCCESS = '@courses/LIKE_YOU_SUCCESS',
    START_LESSON_REQUEST = '@courses/START_LESSON_REQUEST',
    START_LESSON_SUCCESS = '@courses/START_LESSON_SUCCESS',
    START_LESSON_FAILURE = '@courses/START_LESSON_FAILURE',
    FINISH_LESSON_REQUEST = '@courses/FINISH_LESSON_REQUEST',
    FINISH_LESSON_SUCCESS = '@courses/FINISH_LESSON_SUCCESS',
    FINISH_LESSON_FAILURE = '@courses/FINISH_LESSON_FAILURE',
    COURSES_IN_PROGRESS_CLEAR = '@courses/COURSES_IN_PROGRESS_CLEAR',
    UPDATE_COURSE_STUDENT_VIEW_REQUEST = '@courses/UPDATE_COURSE_STUDENT_VIEW_REQUEST',
    UPDATE_COURSE_STUDENT_VIEW_SUCCESS = '@courses/UPDATE_COURSE_STUDENT_VIEW_SUCCESS',
    UPDATE_COURSE_STUDENT_VIEW_FAILURE = '@courses/UPDATE_COURSE_STUDENT_VIEW_FAILURE',
    UPDATE_CONTENT_STUDENT_VIEW_IN_COURSES = '@course/UPDATE_CONTENT_STUDENT_VIEW_IN_COURSES',
    GET_COURSE_STUDENT_VIEW_REQUEST = '@courses/GET_COURSE_STUDENT_VIEW_REQUEST',
    GET_COURSE_STUDENT_VIEW_SUCCESS = '@courses/GET_COURSE_STUDENT_VIEW_SUCCESS',
    GET_COURSE_STUDENT_VIEW_FAILURE = '@courses/GET_COURSE_STUDENT_VIEW_FAILURE',
    CLEAR_COURSE = '@courses/CLEAR_COURSE',
    REMOVE_COURSE_FROM_LIST = '@courses/REMOVE_COURSE_FROM_LIST',
    REMOVE_PROGRAM_FROM_LIST = '@courses/REMOVE_PROGRAM_FROM_LIST',
    INITIALIZE_RECOMMENDATION_COURSE_LIST_STATE = '@courses/INITIALIZE_RECOMMENDATION_COURSE_LIST_STATE',
    COURSES_CLEAR = '@courses/COURSES_CLEAR',
    SEARCHED_SUCCESS = '@course/SEARCHED_SUCCESS',
    COURSES_SEARCHED_CLEAR = '@course/COURSES_SEARCHED_CLEAR',
    CREATE_COURSE_REQUEST = '@course/CREATE_COURSE_REQUEST',
    CREATE_COURSE_SUCCESS = '@course/CREATE_COURSE_SUCCESS',
    CREATE_COURSE_FAILURE = '@course/CREATE_COURSE_FAILURE',
    CREATE_COURSE_RESET = '@course/CREATE_COURSE_RESET',
    UPDATE_COURSE_REQUEST = '@course/UPDATE_COURSE_REQUEST',
    UPDATE_COURSE_SUCCESS = '@course/UPDATE_COURSE_SUCCESS',
    UPDATE_COURSE_FAILURE = '@course/UPDATE_COURSE_FAILURE',
    UPDATE_COURSE_RESET = '@course/UPDATE_COURSE_RESET',
    MY_COURSES_SUCCESS = '@course/MY_COURSES_SUCCESS',
    SET_COURSE_FOR_INSERTION = '@course/SET_COURSE_FOR_INSERTION',
    ASSOCIATE_COURSE_RESET = '@course/ASSOCIATE_COURSE_RESET',
    ADD_CONTENT_TO_COURSE_REQUEST = '@course/ADD_CONTENT_TO_COURSE_REQUEST',
    ADD_CONTENT_TO_COURSE_SUCCESS = '@course/ADD_CONTENT_TO_COURSE_SUCCESS',
    ADD_CONTENT_TO_COURSE_FAILURE = '@course/ADD_CONTENT_TO_COURSE_FAILURE',
    MY_COURSES_CLEAR = '@course/MY_COURSES_CLEAR',
    GET_COURSE_REQUEST = '@course/GET_COURSE_REQUEST',
    GET_COURSE_SUCCESS = '@course/GET_COURSE_SUCCESS',
    GET_COURSE_FAILURE = '@course/GET_COURSE_FAILURE',
    GET_COURSE_CLEAR = '@course/GET_COURSE_CLEAR',
    UPDATE_SCORM_PACKAGE_REQUEST = '@course/UPDATE_SCORM_PACKAGE_REQUEST',
    UPDATE_SCORM_PACKAGE_SUCCESS = '@course/UPDATE_SCORM_PACKAGE_SUCCESS',
    UPDATE_SCORM_PACKAGE_FAILURE = '@course/UPDATE_SCORM_PACKAGE_FAILURE',
    GET_SCORM_PACKAGE_STATUS_REQUEST = '@course/GET_SCORM_PACKAGE_STATUS_REQUEST',
    GET_SCORM_PACKAGE_STATUS_SUCCESS = '@course/GET_SCORM_PACKAGE_STATUS_SUCCESS',
    GET_SCORM_PACKAGE_STATUS_FAILURE = '@course/GET_SCORM_PACKAGE_STATUS_FAILURE',
    GET_SCORM_PACKAGE_STATUS_CLEAR = '@course/GET_SCORM_PACKAGE_STATUS_CLEAR',
    COURSES_COMPLETED_CLEAR = '@courses/COURSES_COMPLETED_CLEAR',
    CLEAR_ARCHIVE_CONFIGURATION = '@course/CLEAR_ARCHIVE_CONFIGURATION',
    CLEAR_UPDATE_CONFIGURATION = '@course/CLEAR_UPDATE_CONFIGURATION',
    PUBLISHED_USER_CONTENTS_CLEAR = '@courses/PUBLISHED_USER_CONTENTS_CLEAR',
    INCREASE_COURSE_VIEWS_REQUEST = '@courses/INCREASE_COURSE_VIEWS_REQUEST',
    INCREASE_COURSE_VIEWS_SUCCESS = '@courses/INCREASE_COURSE_VIEWS_SUCCESS',
    INCREASE_COURSE_VIEWS_FAILURE = '@courses/INCREASE_COURSE_VIEWS_FAILURE',
    START_ENROLLMENT_REQUEST = '@courses/START_ENROLLMENT_REQUEST',
    START_ENROLLMENT_SUCCESS = '@courses/START_ENROLLMENT_SUCCESS',
    START_ENROLLMENT_FAILURE = '@courses/START_ENROLLMENT_FAILURE',
    TRAININGS_SUCCESS = '@courses/TRAININGS_SUCCESS',
    TRAININGS_CLEAR = '@courses/TRAININGS_CLEAR',
}

export interface Lists {
    lists: [List];
    total: number;
}

export interface CourseStudentView {
    course: List;
    courseEnrollment: CourseEnrollment;
    classEnrollment: ClassEnrollment;
    percentAsStr: string;
    programClass: ProgramClass;
}

export interface ListCourseStudentViewData {
    list: CourseStudentView[];
    total: number;
    totalToExpire: number;
    loading: boolean;
    categoryId?: number;
}

export interface ListsState {
    data: Lists;
    courseData: CourseLessonContentTO;
    list?: List;
    refreshList?: boolean;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
    success: boolean;
    successOnCreateCourse: boolean;
    successOnUpdateScorm: boolean;
    hasErrorOnUpdateScorm: boolean;
    listData: {
        [key: string]: ListCourseStudentViewData;
        listLastPublishedStudentView: ListCourseStudentViewData;
        listMostAccessedStudentView: ListCourseStudentViewData;
        listInProgressStudentView: ListCourseStudentViewData;
        listCompletedStudentView: ListCourseStudentViewData;
        listTopRatedStudentView: ListCourseStudentViewData;
        listFavoriteStudentView: ListCourseStudentViewData;
        listForYouStudentView: ListCourseStudentViewData;
        listCoursesHavingAContentStudentView: ListCourseStudentViewData;
        listSearchResultStudentView: ListCourseStudentViewData;
        listMyCourseStudentView: ListCourseStudentViewData;
        listEssentialStudentView: ListCourseStudentViewData;
        listPublishedUserContentsStudentView: ListCourseStudentViewData;
        listTrainingsEnrolledStudentView: ListCourseStudentViewData;
    };
    currentData: CourseStudentView;
    isUserCreatingList?: boolean;
    isUserAssociatingList?: boolean;
    selectedCourseForInsertion: List | null;
    scormPackageStatus?: ScormStatus;
    successOnUpdateCourseStudentView: boolean;
    successOnPublishList: boolean;
    successOnArchiveList: boolean;
    successOnUpdateList: boolean;
    hasErrorOnUpdate: boolean;
    hasErrorOnArchive: boolean;
    total?: number;
}
